import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=344d10e2&"
import script from "./userAgreement.vue?vue&type=script&lang=js&"
export * from "./userAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('344d10e2')) {
      api.createRecord('344d10e2', component.options)
    } else {
      api.reload('344d10e2', component.options)
    }
    module.hot.accept("./userAgreement.vue?vue&type=template&id=344d10e2&", function () {
      api.rerender('344d10e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/userAgreement.vue"
export default component.exports